import React from 'react';

export default function ProductsTable({ products, rowUI, setRowUiField, handleLocalChange, handleSave, savingId, API_BASE_URL }) {
  return (
    <div className="overflow-x-auto">
      <table className="min-w-full border text-sm">
        <thead className="bg-gray-50">
          <tr>
            <th className="p-2 border">product_id</th>
            <th className="p-2 border text-left">product_name</th>
            <th className="p-2 border text-left">group</th>
            <th className="p-2 border">stock</th>
            <th className="p-2 border">price</th>
            <th className="p-2 border text-left">subname</th>
            <th className="p-2 border">sponsored</th>
            <th className="p-2 border">active</th>
            <th className="p-2 border">uploads / URLs</th>
            <th className="p-2 border">mode</th>
            <th className="p-2 border">save</th>
          </tr>
        </thead>
        <tbody>
          {products.map((p) => {
            const ui = rowUI[p.id] || { files: [], urlsText: '', mode: 'keep' };
            return (
              <tr key={p.id} className="align-top">
                <td className="p-2 border text-center">{p.product_id}</td>
                <td className="p-2 border">{p.product_name}</td>
                <td className="p-2 border">{p.product_group_name || '-'}</td>
                <td className="p-2 border text-center">{p.stock_count ?? 0}</td>
                <td className="p-2 border text-center">{p.price ?? '-'}</td>

                <td className="p-2 border">
                  <input
                    className="w-48 border rounded p-1"
                    value={p.subname || ''}
                    onChange={(e) => handleLocalChange(p.id, 'subname', e.target.value)}
                    placeholder="subname…"
                  />
                </td>

                <td className="p-2 border text-center">
                  <input
                    type="checkbox"
                    checked={!!p.sponsored}
                    onChange={(e) => handleLocalChange(p.id, 'sponsored', e.target.checked)}
                  />
                </td>

                <td className="p-2 border text-center">
                  <input
                    type="checkbox"
                    checked={!!p.is_active}
                    onChange={(e) => handleLocalChange(p.id, 'is_active', e.target.checked)}
                  />
                </td>

                {/* Uploads / URLs */}
                <td className="p-2 border">
                  <div className="flex flex-col gap-2 w-56">
                    <input
                      type="file"
                      multiple
                      onChange={(e) => setRowUiField(p.id, 'files', Array.from(e.target.files || []))}
                    />
                    {(ui.files?.length || 0) > 0 && (
                      <div className="text-xs text-gray-500">Selected files: {ui.files.length}</div>
                    )}
                    <div className="flex gap-1 flex-wrap max-w-[160px]">
                    {(p.images || []).map(img => {
                      const src = img.externalUrl ? img.externalUrl : `${API_BASE_URL}/uploads/${img.filename}`;
                      return (
                        <img
                          key={`${img.id}-${src}`}
                          src={src}
                          alt={p.product_name}
                          className="w-12 h-12 object-cover rounded"
                        />
                      );
                    })}
                  </div>
                  </div>
                </td>

                <td className="p-2 border">
                  <button
                    className="bg-black text-white px-3 py-1 rounded disabled:opacity-60"
                    disabled={savingId === p.id}
                    onClick={() => handleSave(p)}
                  >
                    {savingId === p.id ? 'Saving…' : 'Save'}
                  </button>
                </td>
              </tr>
            );
          })}
          {products.length === 0 && (
            <tr>
              <td className="p-4 text-center text-gray-500" colSpan={12}>
                No products match your search.
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}